import { colors } from '@kmns-internal/furikake'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { ResponseTypeEnum } from '@ulysses-inc/harami_api_client'
import { COLUMN_FORM_INPUT_OPTIONS, type ColumnFormInputType } from '../model'

type Props = {
  selectedType?: ResponseTypeEnum
  onSelect: (type: ColumnFormInputType) => void
}

/**
 * 「入力フォーム」型(テキスト/数値/日時/署名)を選ぶアイコンパレット。
 * 選択肢/セット選択肢は型ではなく専用パネルで選ぶため、ここには含まれない。
 */
export const InputFormTypePalette = ({ selectedType, onSelect }: Props) => (
  <Box sx={{ flexShrink: 0, width: 240, p: 1 }}>
    <Typography variant="body2" fontWeight={700} sx={{ px: 1.5, py: 1 }}>
      入力フォーム
    </Typography>
    <Stack spacing={0.25}>
      {COLUMN_FORM_INPUT_OPTIONS.map(({ type, label, Icon }) => {
        const selected = selectedType === type
        return (
          <ButtonBase
            key={type}
            onClick={() => onSelect(type)}
            aria-pressed={selected}
            sx={{
              justifyContent: 'flex-start',
              gap: 1.5,
              px: 1.5,
              py: 1,
              borderRadius: 1,
              width: '100%',
              bgcolor: selected ? colors.primary.selected : 'transparent',
              '&:hover': {
                bgcolor: selected
                  ? colors.primary.selected
                  : colors.action.hover,
              },
            }}
          >
            <Box
              sx={{
                flex: '0 0 auto',
                display: 'inline-flex',
                width: 24,
                height: 24,
              }}
            >
              <Icon width={24} height={24} />
            </Box>
            <Typography
              variant="body2"
              fontWeight={selected ? 700 : 400}
              color={selected ? 'primary' : undefined}
            >
              {label}
            </Typography>
          </ButtonBase>
        )
      })}
    </Stack>
  </Box>
)
